// extracted by mini-css-extract-plugin
export default {"header":"CurrentMatchFlow_header__psCnl","headerTitle":"CurrentMatchFlow_headerTitle__r4y4p","body":"CurrentMatchFlow_body__LjNdH","result":"CurrentMatchFlow_result__IthGO"};